import deviceService from '../service/device'
const state = {
    query: {
        macAddress: "",
        partner: "",
        customer: "",
        type: "",
        version: "",
        page: 1,
        pageSize: 10,
    },
    searchResult: {
        total: 0,
        devices: [],
    },
    firmwares: [],
    deviceTypes: [],
    loading: false
}

const actions = {
    updateDevice({ commit }, device) {
        return deviceService.updateDevice(device).then(data => {
            commit('setDevice', data);
            return data;
        }).catch((e) => {
            console.log(e)
            commit('setLoading', false)
        })
    },
    createDevice({ commit }, device) {
        return deviceService.createDevice(device).then(data => {
            device._id = data._id;
            commit('addDevice', device);
            return data;
        })
    },
    deleteDevice({ commit }, id) {
        return deviceService.deleteDevice(id).then(() => {
            commit('removeDevice', id);
            return id;
        })
    },
    getDeviceTypes({ commit }) {
        return deviceService.getDeviceTypes().then(deviceTypes => {
            commit('setDeviceTypes', deviceTypes);
        })
    },
    getDeviceFirmwares({ commit }, query) {
        return deviceService.getDeviceFirmwares(query).then(firmwares => {
            commit('setDeviceFirmwares', firmwares);
        }).catch((e) => {
            console.log(e)
        })
    },

    getDeviceVersion({ commit }, query) {
        commit('setLoading', true)
        return deviceService.getDeviceVersion(query).then(() => {
            commit('setLoading', false)
        }).catch((e) => {
            console.log(e)
        })
    },

    updateDeviceFirmwares({ commit }, query) {
        return deviceService.updateDeviceFirmwares(query).then((data) => {
            return data
        }).catch(() => {
            commit('setLoading', false)
        })
    },
    getDevices({ commit }, query) {
        commit('setQuery', query)
        commit('setLoading', true)
        return deviceService.getDevices(query).then(devices => {
            commit('setDevices', devices);
        }).catch(() => {
            commit('setLoading', false)
        })
    },

}
const mutations = {
    addDevice(state, device) {
        state.searchResult.devices.push(device)
    },
    removeDevice(state, id) {
        var index = state.searchResult.devices.findIndex(x => x._id == id)
        if (index != -1) {
            state.searchResult.devices.splice(index, 1)
        }
    },
    setDeviceTypes(state, deviceTypes) {
        state.deviceTypes = deviceTypes
    },
    setDeviceFirmwares(state, firmwares) {
        state.firmwares = firmwares.firmwares
        state.loading = false;
    },
    setDevice(state, device) {
        let index = state.searchResult.devices.findIndex(x => x._id == device._id)
        if (index != -1) {
            state.searchResult.devices[index].customer = device.customer
            state.searchResult.devices[index].version = device.version
        }
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setDevices(state, devices) {
        state.searchResult = devices
        state.loading = false
    },
    setQuery(state, query) {
        state.query = query
    },

}
export default {
    namespaced: true,
    state,
    actions,
    mutations
}



